import { CrossLightIcon, FilterLightIcon } from '@global-engineering-shared/gweb-global-icons';
import { Button, Drawer, Typography } from '@global-engineering-shared/gweb-material-ui';
import React, { useState } from 'react';

import useStyles from 'components/Filter/Filter.styles';
import { useFilters } from 'context/FilterProvider/FilterProvider';
import { areFiltersDefault } from 'context/FilterProvider/utils/areFiltersDefault';
import { getNumberOfActiveFilters } from 'context/FilterProvider/utils/getNumberOfActiveFilters';
import FilterChipsContainer from 'features/Frames/components/FilterChipsContainer';
import FramesFilters from 'features/Frames/components/Frames/FramesFilters';

const Filter = () => {
  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const { filters } = useFilters();

  return (
    <div className={classes.main}>
      <span hidden={areFiltersDefault(filters)}>
        <FilterChipsContainer />
      </span>
      <div className={classes.filterButtonContainer}>
        <Button
          variant="outlined"
          onClick={() => setDrawerOpen(!drawerOpen)}
          className={classes.filterButton}
        >
          <FilterLightIcon className={classes.filterIcon} />
          <Typography className={classes.filterButtonText}>Add Filters</Typography>
          <div className={classes.circle} hidden={areFiltersDefault(filters)}>
            {getNumberOfActiveFilters(filters)}
          </div>
        </Button>
      </div>
      <Drawer
        className={classes.filterDrawer}
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(!drawerOpen)}
      >
        <div className={classes.filterDrawerDiv}>
          <div>
            <Typography variant="h3" fontWeight="bold" className={classes.filterTypography}>
              Filters
            </Typography>
            <CrossLightIcon
              data-testid="cross-light-icon"
              onClick={() => setDrawerOpen(false)}
              className={classes.closeIcon}
            />
          </div>
          <FramesFilters setDrawerOpen={setDrawerOpen} />
        </div>
      </Drawer>
    </div>
  );
};
export default Filter;
